export default __webpack_public_path__ + "static/media/empty-avatar.f2391c21.jpg";